<template>
  <v-dialog v-model="localDialog" width="40%" @update:modelValue="updateDialog" transition=""persistent :open-delay="0" :close-delay="0">
    <v-card>
        <v-card-title class="text-h6">
            <span>{{ isEntryMode ? 'Add Menu' : 'Update Menu' }}</span>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text>
            <v-form @submit.prevent="submit" ref="menuSetup">
              <v-row>
                  <v-col cols="12">   
                      <v-autocomplete
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="sub_module_id.value.value"
                        :items="getSubModuleList.filter(item=> item.status == 1)"
                        :item-title="item => item && item.name && item.code ? `${item.name} - ${item.code} (${item.module.name})` : ''"                                                  
                        item-value="id"
                        :error-messages="sub_module_id.errorMessage.value"
                        clearable                        
                      >
                        <template #label>
                          Sub Module <span class="text-red-accent-4">*</span>
                        </template>
                      </v-autocomplete> 

                      <v-text-field
                          density="compact"
                          variant="outlined"
                          bg-color="grey-lighten-4"
                          v-model="name.value.value"
                          :error-messages="name.errorMessage.value"
                          clearable
                      >
                        <template #label>
                          Name <span class="text-red-accent-4">*</span>
                        </template>
                      </v-text-field>

                      <v-text-field
                          label="Serial"
                          density="compact"
                          variant="outlined"
                          bg-color="grey-lighten-4"
                          v-model="sl.value.value"
                          :error-messages="sl.errorMessage.value"
                          clearable
                      >
                        <template #label>
                          Serial <span class="text-red-accent-4">*</span>
                        </template>
                      </v-text-field>

                      <v-text-field
                        label="Icon"
                        density="compact"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="icon.value.value"
                        :error-messages="icon.errorMessage.value"
                        clearable
                      >
                        <template #label>
                          Icon <span class="text-red-accent-4">*</span>
                        </template>
                      </v-text-field>

                      <v-text-field
                          density="compact"
                          variant="outlined"
                          bg-color="grey-lighten-4"
                          v-model="menu_url.value.value"
                          :error-messages="menu_url.errorMessage.value"
                          clearable
                      >
                        <template #label>
                          URL <span class="text-red-accent-4">*</span>
                        </template>
                      </v-text-field> 

                      <v-row>
                          <v-col cols="4">
                            <v-checkbox                            
                                label="Insert"
                                v-model="insert.value.value"
                                :error-messages="insert.errorMessage.value"
                                density="compact"
                                variant="outlined"
                                hide-details
                                single-line
                                color="success"
                                value="1"
                            ></v-checkbox>
                          </v-col>
                          <v-col cols="4">
                            <v-checkbox                            
                                label="Update"
                                v-model="update.value.value"
                                :error-messages="status.errorMessage.value"
                                density="compact"
                                variant="outlined"
                                hide-details
                                single-line
                                color="info"
                                value="1"
                            ></v-checkbox>
                          </v-col>
                          <v-col cols="4">
                            <v-checkbox                            
                                label="Delete"
                                v-model="trash.value.value"
                                :error-messages="trash.errorMessage.value"
                                density="compact"
                                variant="outlined"
                                hide-details
                                single-line
                                color="red"
                                value="1"
                            ></v-checkbox>
                          </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="6">
                          <v-checkbox
                            label="Active"
                            v-model="status.value.value"
                            :error-messages="status.errorMessage.value"
                            density="compact"
                            variant="outlined"
                            hide-details
                            single-line
                            color="primary"
                            value="1"
                          />
                        </v-col>

                        <v-col cols="6">
                          <v-checkbox
                            label="Is App"
                            v-model="is_app.value.value"
                            :error-messages="is_app.errorMessage.value"
                            density="compact"
                            variant="outlined"
                            hide-details
                            single-line
                            color="primary"
                            value="1"
                          />
                        </v-col>
                      </v-row>

                      <input v-model="menu_id.value.value" type="hidden">                              
                  </v-col>
              </v-row>
              <v-divider></v-divider>
              <v-card-actions>
                  <v-layout class="justify-end">
                      <v-btn class="bg-red" variant="flat" type="reset"@click="closeDialog">Close</v-btn>
                        <v-btn 
                        class="bg-brand w-15 ms-2"  
                        variant="flat" 
                        type="submit"
                        >
                        {{ isEntryMode ? 'Save' : 'Update' }}
                        </v-btn>
                  </v-layout>
              </v-card-actions>
            </v-form>
        </v-card-text>
      
    </v-card>
  </v-dialog>
</template>

<script>
import { ref, watch } from 'vue'
import { useStore } from 'vuex'
import { useField, useForm } from 'vee-validate'
import * as yup from 'yup'
import { toast } from 'vue3-toastify'

export default {
  name: 'ModuleSetup',
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => ({
        name: '',
        icon: '',
        sl: '',
        menu_url: '',
        status: '1',
        is_app: '1',
        insert: 1, 
        update: 1, 
        trash: 0,
        sub_module_id: null,
        menu_id: null,
      })
    }
  },
  data() {
    return {
      localDialog: this.dialog,
      errorMessages: '',
      loading: false,
      isEntryMode: true,
    }
  },
  computed: {
    getSubModuleList() {
      return this.$store.getters.getSubModuleList;
    },
  },
  watch: {
    dialog(val) {
      this.localDialog = val
    },
    localDialog(val) {
      this.$emit('update:dialog', val)
    },
    data: {
      handler(newData) {
        this.isEntryMode = !newData.id;
        this.resetForm({ errors: {}, touched: {} });
        this.name.setValue(newData.name || '', false);
        this.icon.setValue(newData.icon || '', false);
        this.sl.setValue(newData.sl || '', false);
        this.menu_url.setValue(newData.menu_url || '', false);
        this.status.setValue(String(newData.status) || '1', false);
        this.is_app.setValue(String(newData.is_app) || '1', false);
        this.insert.setValue(String(newData.insert) || 1, false);
        this.update.setValue(String(newData.update) || 1, false);
        this.trash.setValue(String(newData.delete) || 0, false);
        this.sub_module_id.setValue(newData.sub_module_id || '', false);
        this.menu_id.setValue(newData.id || '', false);
      },
    }
    
  },
  created() {
     if(this.$store.getters.getSubModuleList.length == 0){
          this.loading = true;
            this.$store.dispatch('getSubModuleList').then((response) => {
              this.loading = false;
          })
      };
  },
  methods: {
    updateDialog(val) {
      this.$emit('update:dialog', val)
    },
    closeDialog() {
        this.$emit('update:dialog', false);
    },
  },
  setup(props, { emit }){
    const { handleSubmit, resetForm} = useForm({
      validationSchema: yup.object({
          name: yup.string().min(1).max(50).required().trim().label('Name'),
          icon: yup.string().min(1).max(50).required().trim().label('Icon'),
          sl: yup.number().positive().integer().required().label('SL'),
          menu_url: yup.string().required('Please enter url').label('Url'),
          sub_module_id: yup.number().positive().integer().required().label('Sub Module Name'),
      }),

    });

    const name = useField('name');
    const icon = useField('icon');
    const sl = useField('sl');
    const menu_url = useField('menu_url');
    const status = useField('status');
    const is_app = useField('is_app');
    const insert = useField('insert');
    const update = useField('update');
    const trash = useField('trash');
    const sub_module_id = useField('sub_module_id');
    const menu_id = useField('menu_id');
    const errorMessages  = ref('');
    const loading  = ref('');
    const store = useStore();

    const submit = handleSubmit((values) => {
        store.dispatch("saveUpdateMenuSetup", values)
            .then((response) => {
                resetForm();
                emit('update:dialog', false);
                toast.success(response.data.message);
                loading.value = true;
                store.dispatch('getMenuList')
                    .then(data => {
                        loading.value = false;
                    })
                    .catch(error => {
                        loading.value = false;
                        toast.error(error.response.data.message);
                    })
            })
            .catch((error) => {            
                toast.error(error.response.data.message);          
            })
    });
    return {
      submit,
      name,
      icon,
      sl,
      menu_url,
      status,
      is_app,
      insert,
      update,
      trash,
      errorMessages,
      sub_module_id,
      menu_id,
      resetForm,
      loading
    }
  },
  mounted() {
  }
}
</script>

